(() => {
  const page = document.getElementById('DgOrderTracking');
  if (page && !page.dataset.dgtChatBound) {
    page.dataset.dgtChatBound = 'true';
    page.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('[data-dgt-chat]') : null;
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (typeof window.Intercom !== 'function') return;
      try {
        window.Intercom('show');
        event.preventDefault();
      } catch {
        // Preserve the contact-page link when the existing chat cannot open.
      }
    });
  }
  if (!customElements.get('dg-transit-estimator')) {
    customElements.define('dg-transit-estimator', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const select = this.querySelector('[data-dgt-state]');
        if (!select) return;
        const update = () => {
          const option = select.selectedOptions[0];
          const valid = Boolean(option?.dataset.ground && option?.dataset.priority);
          const format = value => value.split(',').filter((day, index, days) => index === 0 || day !== days[0]).join('–');
          this.querySelector('[data-dgt-ground]').textContent = valid ? format(option.dataset.ground) : '—';
          this.querySelector('[data-dgt-priority]').textContent = valid ? format(option.dataset.priority) : '—';
          this.querySelectorAll('[data-dgt-unit]').forEach(node => { node.textContent = valid ? this.dataset.days : this.dataset.choose; });
          this.querySelector('[data-dgt-remote]').hidden = !['AK', 'HI'].includes(select.value);
          const ground = valid ? option.dataset.ground.split(',').map(Number) : [];
          const priority = valid ? option.dataset.priority.split(',').map(Number) : [];
          this.querySelector('[data-dgt-similar]').hidden = !valid || Math.max(ground[0], priority[0]) > Math.min(ground[1], priority[1]);
          const section = this.closest('.dgt-delivery');
          const destination = section?.querySelector('[data-dgt-destination]');
          if (destination) destination.textContent = valid ? option.textContent.trim() : this.dataset.statePlaceholder;
          section?.querySelectorAll('[data-dgt-map-state]').forEach(node => node.classList.toggle('is-selected', valid && node.dataset.dgtMapState === select.value));
        };
        select.addEventListener('change', update, { signal: this.controller.signal });
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
})();
